
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"clip-path"}},[_c('rect',{attrs:{"id":"Rectangle_16713","data-name":"Rectangle 16713","width":"21","height":"21","transform":"translate(-.104 -.104)","fill":"#7367ff"}})])]),_c('g',{attrs:{"id":"Group_49539","data-name":"Group 49539","transform":"translate(-549 -762)"}},[_c('g',{attrs:{"id":"Group_49191","data-name":"Group 49191"}},[_c('rect',{attrs:{"id":"Rectangle_16687","data-name":"Rectangle 16687","width":"30","height":"30","rx":"9","transform":"translate(549 762)","fill":"#e0e0fe","opacity":".549"}}),_c('g',{attrs:{"id":"Mask_Group_22292","data-name":"Mask Group 22292","transform":"translate(554.104 767.104)","clip-path":"url(#clip-path)"}},[_c('g',{attrs:{"id":"Group_47247","data-name":"Group 47247","transform":"translate(.8 .8)"}},[_c('path',{attrs:{"id":"Path_35507","data-name":"Path 35507","d":"M9.597 3.198v12.8m-3.2-3l.938.7a3.986 3.986 0 004.521 0 2.006 2.006 0 000-3.393 3.776 3.776 0 00-2.26-.7 3.423 3.423 0 01-2.133-.7 2.065 2.065 0 010-3.393 3.586 3.586 0 014.266 0l.448.352m7.016 3.744a9.6 9.6 0 11-9.6-9.6 9.6 9.6 0 019.6 9.588z","fill":"none","stroke":"#7367ff","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}})])])])])])
          )
        }
      }
    